import { ca } from '@cian/analytics';

export const trackPublicationClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'B2BLanding',
    action: 'Click',
    label: 'Publication',
  });
};
